import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotTopicsGrid from './components/HotTopicsGrid';
import DailyCompetitionSection from './components/DailyCompetitionSection';
import FeatureGrid from './components/FeatureGrid';
import CTASection from './components/CTASection';

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '吃瓜网',
  url: 'https://chiguawang.com',
  description: '吃瓜网官网独家爆料，24小时速报黑料八卦，吃瓜第一站。每日实时追踪今日大瓜、明星塌房事件、网红反差视频及每日大赛最新动态。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://chiguawang.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '吃瓜网 - 首页',
  description: '吃瓜网官网独家爆料，24小时速报黑料八卦，吃瓜第一站',
  url: 'https://chiguawang.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '吃瓜网',
    url: 'https://chiguawang.com',
  },
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotTopicsGrid />
        <DailyCompetitionSection />
        <FeatureGrid />
        <CTASection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
    </>
  );
}